import type { ReactElement } from 'react';
import type { IconRenderProps } from '../types';

export function ThreadsIcon({
	width,
	height,
	active = false,
	'aria-label': ariaLabel = 'Threads',
	style,
	customIconColor,
	...rest
}: IconRenderProps): ReactElement {
	const bg = customIconColor?.bgColor ?? '#FFFFFF';
	const g = customIconColor?.glyphColor ?? (active ? '#1E1E1E' : 'rgba(30, 30, 30, 0.48)');

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width ?? '100%'}
			height={height ?? '100%'}
			viewBox="0 0 40 40"
			fill="none"
			role="img"
			aria-label={ariaLabel}
			style={{ display: 'block', ...style }}
			{...rest}
		>
			<title>Threads</title>

			<rect width="40" height="40" rx="8" fill={bg} />

			<path
				d="M378.5 237.3c-2.2-1.1-4.4-2.1-6.7-3-4-72.8-43.7-114.5-110.6-114.9h-.9c-40 0-73.2 17.1-93.7 48.1l36.7 25.2c15.3-23.2 39.3-28.1 56.9-28.1h.6c22 .1 38.6 6.5 49.3 19q11.7 13.65 15.6 37.5c-19.5-3.3-40.6-4.3-63.1-3-63.5 3.7-104.4 40.7-101.6 92.2 1.4 26.1 14.4 48.6 36.6 63.3 18.8 12.4 43 18.5 68.2 17.1 33.2-1.8 59.3-14.5 77.5-37.7 13.8-17.6 22.5-40.4 26.4-69.1 15.8 9.6 27.6 22.1 34 37.2 11 25.7 11.7 67.9-22.8 102.3-30.2 30.2-66.5 43.2-121.3 43.6-60.8-.5-106.8-20-136.7-58-28-35.6-42.5-87-43-152.8.5-65.8 15-117.2 43-152.8 29.9-38 75.9-57.5 136.7-58 61.3.5 108.1 20.1 139.1 58.3 15.2 18.7 26.7 42.3 34.3 69.8l43.1-11.5c-9.2-33.8-23.6-63-43.3-87.1C393.2 25.6 335 .5 259.9 0h-.3C184.8.5 127.2 25.7 88.5 74.9c-34.4 43.8-52.2 104.6-52.8 180.9v.4c.6 76.3 18.3 137.2 52.8 180.9 38.7 49.2 96.2 74.4 171.1 74.9h.3c66.6-.5 113.5-17.9 152.1-56.5 50.6-50.5 49-113.8 32.4-152.7-11.9-27.9-34.7-50.5-65.9-65.5M263.6 345.4c-27.8 1.6-56.8-10.9-58.2-37.7-1.1-19.8 14.1-42 59.9-44.6 5.2-.3 10.4-.5 15.4-.5 16.6 0 32.2 1.6 46.3 4.7-5.2 65.9-36.1 76.6-63.4 78.1"
				fill={g}
				transform="translate(3.5 35) scale(0.055) translate(30 -512)"
			/>
		</svg>
	);
}
